const padCalendarPart = (value: number) => String(value).padStart(2, '0')

/** Serialises a calendar day without converting it through UTC. */
export const serializeLocalCalendarDate = (date: Date) =>
  `${date.getFullYear()}-${padCalendarPart(date.getMonth() + 1)}-${padCalendarPart(date.getDate())}`

/** Parses a calendar-day value into the user's local calendar day. */
export const parseLocalCalendarDate = (value: string): Date | null => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
  if (!match) return null

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const parsed = new Date(year, month - 1, day)

  return parsed.getFullYear() === year &&
    parsed.getMonth() === month - 1 &&
    parsed.getDate() === day
    ? parsed
    : null
}

export const copyLocalCalendarDate = (date: Date) =>
  parseLocalCalendarDate(serializeLocalCalendarDate(date)) ?? new Date(date.getTime())

/** A calendar day the API keeps at UTC midnight, as the local day the calendar picks. */
export const fromUtcDay = (date: Date) =>
  new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())

export const calendarDayNumber = (date: Date) =>
  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
